import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';

import { Table as ShadcnTable, TableBody, TableHeader } from '@/components/ui/table';
import { columnShape, dataShape } from '../../types';
import EmptyContent from './EmptyContent';
import Header from './Header';
import Row from './Row';

const Table = ({ columns, data }) => {
  const [sorting, setSorting] = useState([]);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting,
    state: {
      sorting,
    },
  });

  return (
    <ShadcnTable>
      <TableHeader className="bg-muted">
        {table.getHeaderGroups().map((headerGroup) => (
          <Header headerGroup={headerGroup} key={headerGroup.id} />
        ))}
      </TableHeader>

      <TableBody>
        {table.getRowModel().rows?.length ? (
          table.getRowModel().rows.map((row) => <Row key={row.id} row={row} />)
        ) : (
          <EmptyContent columns={columns} />
        )}
      </TableBody>
    </ShadcnTable>
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(columnShape).isRequired,
  data: PropTypes.arrayOf(dataShape).isRequired,
};

export default Table;
